import { createWrittenAccountPreviews } from "./WrittenAccountPreviews";

export const WrittenAccountPreviewsOpen = createWrittenAccountPreviews(
	"written_accounts_open",
	(account) =>
		account.hasBeenActive && account.status !== "closed" && account.status !== "declined",
);
